import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="open-create-community-space-modal"
export default class extends Controller {
  static targets = ["trigger"]
  static values = {
    modalUrl: String,
    targetId: String,
  }

  open() {
    const turboFrame = document.getElementById("modal_content")
    if (turboFrame) {
      const queryParams = new URLSearchParams({
        select_id: this.targetIdValue,
      })
      turboFrame.src = `${this.modalUrlValue}?${queryParams.toString()}`
    }
    document.dispatchEvent(new CustomEvent("modal:show"))
  }
}
